import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../component/Common/Button";
import Input from "../../component/Common/Input";
import TextArea from "../../component/Common/TextArea";
import { useForm } from "../../hooks/useForm";
import {
  addMobileConfigData,
  getMobileConfigDetail,
} from "../../store/slice/mobileConfigSlice";

const MobileConfiguration = () => {
  const dispatch = useDispatch();
  const configData = useSelector(
    (state) => state.mobileConfig.mobileConfigDetail
  );

  useEffect(() => {
    dispatch(getMobileConfigDetail());
  }, [dispatch]);

  const initialFValues = useCallback(() => {
    // if (!configData) return;
    return getInitialLeadState(configData);
  }, [configData]);

  const getInitialLeadState = (configData) => {
    return {
      title: configData ? configData?.title : "",
      minimum_version: configData ? configData?.minimum_version : "",
      current_version: configData ? configData?.current_version : "",
      current_version_name: configData ? configData?.current_version_name : "",
      ios_url: configData ? configData?.ios_url : "",
      android_url: configData ? configData?.android_url : "",
      description: configData ? configData?.description : "",
      notify: configData
        ? configData?.notify === "0"
          ? "not_notify"
          : configData?.notify === "2"
          ? "force_update"
          : "notify"
        : "notify",
    };
  };

  //   const initialFValues = {
  //     title: configData?.length > 0 ? configData[0]?.title : "",
  //     minimum_version:
  //       configData?.length > 0 ? configData[0]?.minimum_version : "",
  //     current_version: configData?.current_version
  //       ? configData?.current_version
  //       : "",
  //     current_version_name: configData?.current_version_name
  //       ? configData?.current_version_name
  //       : "",
  //     ios_url: configData?.ios_url ? configData?.ios_url : "",
  //     android_url: configData?.android_url ? configData?.android_url : "",
  //     description: configData?.description ? configData?.description : "",
  //     notify: configData?.notify ? configData?.notify : false,
  //   };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("title" in fieldValues) {
      temp.title = fieldValues.title ? "" : "Title is Required!";
    }
    if ("minimum_version" in fieldValues) {
      temp.minimum_version = fieldValues.minimum_version
        ? ""
        : "Minimum version is Required!";
    }
    if ("current_version" in fieldValues) {
      temp.current_version = fieldValues.current_version
        ? ""
        : "Current version is Required!";
    }
    if ("current_version_name" in fieldValues) {
      temp.current_version_name = fieldValues.current_version_name
        ? ""
        : "Current version name is Required!";
    }
    if ("ios_url" in fieldValues) {
      temp.ios_url = fieldValues.ios_url ? "" : "iOS URL is Required!";
    }
    if ("android_url" in fieldValues) {
      temp.android_url = fieldValues.android_url
        ? ""
        : "Android URL is Required!";
    }
    if ("description" in fieldValues) {
      temp.description = fieldValues.description
        ? ""
        : "Description is Required!";
    }

    setErrors({ ...temp });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate,
    configData
  );

  const configurationHandler = () => {
    if (validate()) {
      const data = {
        title: values.title,
        minimum_version: values.minimum_version,
        current_version: values.current_version,
        current_version_name: values.current_version_name,
        ios_url: values.ios_url,
        android_url: values.android_url,
        description: values.description,
        notify:
          values.notify === "not_notify"
            ? "0"
            : values.notify === "notify"
            ? "1"
            : "2",
      };
      if (!configData?.id) {
        dispatch(addMobileConfigData({ data: data }));
      } else {
        dispatch(addMobileConfigData({ data: data, id: "1" }));
      }
    }
  };

  return (
    <>
      <div className="comman_btn_container center_back_btn">
        <h2 className="mobile_configuration_heading">
          Mobile App Configuration
        </h2>
      </div>
      <div className="project_edit_main_content">
        <div className="create_from_row">
          <Input
            className="create_from_input_content null"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter Title"
            label="Title"
            id="title"
            name="title"
            value={values?.title}
            onChange={handleInputChange}
            error={errors?.title || ""}
          />
          <Input
            className="create_from_input_content null"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter Minimum Version"
            label="Minimum Version"
            id="minimum_version"
            name="minimum_version"
            value={values?.minimum_version}
            onChange={handleInputChange}
            error={errors?.minimum_version || ""}
          />
          <Input
            className="create_from_input_content null"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter Current Version"
            label="Current Version"
            id="current_version"
            name="current_version"
            value={values?.current_version}
            onChange={handleInputChange}
            error={errors?.current_version || ""}
          />
          <Input
            className="create_from_input_content null"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter Current Version Name"
            label="Current Version Name"
            id="current_version_name"
            name="current_version_name"
            value={values?.current_version_name}
            onChange={handleInputChange}
            error={errors?.current_version_name || ""}
          />

          <TextArea
            className="create_from_input_content col_span_2"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter iOS URL"
            label="iOS URL"
            id="ios_url"
            name="ios_url"
            rows={1}
            value={values?.ios_url}
            onChange={handleInputChange}
            error={errors?.ios_url || ""}
          />
          <TextArea
            className="create_from_input_content col_span_2"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter Android URL"
            label="Android URL"
            id="android_url"
            name="android_url"
            rows={1}
            value={values?.android_url}
            onChange={handleInputChange}
            error={errors?.android_url || ""}
          />
          <TextArea
            className="create_from_input_content col_span_2"
            labelClassName="create_from_label"
            inputClassName="create_from_input"
            errorClassName="err_text"
            type="text"
            placeholder="Enter Description"
            label="Description"
            id="description"
            name="description"
            rows={5}
            value={values?.description}
            onChange={handleInputChange}
            error={errors?.description || ""}
          />

          {/* <div className="create_from_row"> */}
          <div className="create_from_input_content col_span_2">
            <label className="create_from_label">Notify </label>
            <Input
              className="create_from_radio_checkbox_content"
              labelClassName="create_from_radio_label"
              inputClassName="create_from_radio_checkbox"
              errorClassName="err_text"
              type="radio"
              label="Not Notify"
              id="not_notify"
              name="notify"
              value="not_notify"
              onChange={(e) => {
                handleInputChange(e);
              }}
              checked={values?.notify === "not_notify"}
            />
            <Input
              className="create_from_radio_checkbox_content"
              labelClassName="create_from_radio_label"
              inputClassName="create_from_radio_checkbox"
              errorClassName="err_text"
              type="radio"
              label="Notify"
              id="notify"
              name="notify"
              value="notify"
              onChange={(e) => {
                handleInputChange(e);
              }}
              checked={values?.notify === "notify"}
            />
            <Input
              className="create_from_radio_checkbox_content"
              labelClassName="create_from_radio_label"
              inputClassName="create_from_radio_checkbox"
              errorClassName="err_text"
              type="radio"
              label="Force Update"
              id="force_update"
              name="notify"
              value="force_update"
              onChange={(e) => {
                handleInputChange(e);
              }}
              checked={values?.notify === "force_update"}
            />
            {/* <Input
              className="create_from_radio_checkbox_content"
              labelClassName="create_from_radio_label"
              inputClassName="create_from_radio_checkbox"
              errorClassName="err_text"
              type="radio"
              label="Project Wise Customers"
              id="CUSTOMER"
              name="user_type"
              value="CUSTOMER"
              onChange={(e) => {
                handleInputChange(e);
              }}
              checked={values.user_type === "CUSTOMER"}
            /> */}
          </div>
          {/* </div> */}
          {/* <Input
            className="create_from_radio_checkbox_content"
            labelClassName="create_from_radio_label"
            inputClassName="create_from_radio_checkbox"
            type="checkbox"
            id="notify"
            name="notify"
            label="Notify"
            onChange={(e) => onchangeCheckbox(e)}
            checked={values.notify === true}
          /> */}

          <Button
            className="create_from_bottom_btn col_span_2"
            buttonClassName="comman_btn"
            onClick={configurationHandler}
            text={"Save"}
          />
        </div>
      </div>
    </>
  );
};

export default MobileConfiguration;
